import { useTranslation } from 'react-i18next';
import Modal from '../../../components/Modal/Modal';
import { SalesMetric } from './SalesMetrics';

interface Props {
  isModalOpened: boolean;
  closeModal: () => void;
  name?: string;
  data: SalesMetric;
}

export default function SalesMetricsModal({
  isModalOpened,
  closeModal,
  name,
  data,
}: Props) {
  const { t } = useTranslation();

  return (
    <Modal
      isOpened={isModalOpened}
      close={closeModal}
      title={t('Information')}
      name={name}
    >
      <div className='mx-3 pt-3 pb-4 px-3'>
        <div className='Text--20 fw-800'>{t(data.title)}</div>
        <div className='mb-4'>
          {t(
            "The Order Defect Rate (ODR) is a performance metric that Amazon uses to rate the seller's customer service standards. The ODR is calculated based on the number of times the negative metrics (below) were incurred divided by the number of overall orders received within a given period of time."
          )}
        </div>
        <div>{t('Your value is')}</div>
        <div className={`Text--30 fw-900 ${data.valueClassName || ''}`}>
          {data.value}
        </div>
        <div>
          {t(
            'Your Order Defect Rate (ODR) is high. Amazon requires sellers to maintain an ODR under 1% in order to sell in the Amazon Store.'
          )}
        </div>
        <div className='pb-5'>
          {t(
            'An order defect rate above 1% may result in a restriction of your selling privileges, including suspension of seller-fulfilled offers.'
          )}
        </div>
      </div>
    </Modal>
  );
}
